import Vue from 'vue'
import App from './App.vue'
import router from './router'

import vuetify from './plugins/vuetify';


// index.js or main.js
// import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader

Vue.config.productionTip = false;

// Declares Nav Component to be used in App.vue
import Nav from './components/Nav.vue';
Vue.component('nav-component', Nav);
// Declares Header Component (can possibly make this child-component)
import Header from './components/Header.vue';
Vue.component('header-component', Header);
// Footer component
import Footer from './components/Footer.vue';
Vue.component('footer-component', Footer);

new Vue({
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app')
